<template>
    <div class="setup-account">
        <div class="security-question">
            <div class="setup">
                <div v-if="!expired && !broken">
                    <h3>Update answer to your security question</h3>
                    <form class="form" @keypress="send" @submit.prevent>
                        <div class="question">
                            <label>Security Question</label>
                            <span>
                                <strong>{{ question }}</strong>
                            </span>
                        </div>
                        <div>
                            <span>Please enter your choosen security question answer</span>
                            <input type="password" v-model="answer" placeholder="***************">
                            <span class="error" v-if="error.answer">Please enter your security question answer</span>
                        </div>
                        <div class="submit">
                            <button type="button" @click="submit">Continue</button>
                        </div>
                        <div class="text-center">
                            <router-link to="/login">Login</router-link>
                        </div>
                    </form>
                </div>
                <div v-if="expired && !broken" class="expired">
                    <p>
                        <router-link to="/login"><img src="../../public/logo-small.png" /></router-link>
                    </p>
                    <p>Sorry, link has expired</p>
                    <p>
                        <router-link to="/login">Login</router-link>
                    </p>
                </div>
                <div v-if="!expired && broken" class="broken">
                    <p>
                        <router-link to="/login"><img src="../../public/logo-small.png" /></router-link>
                    </p>
                    <p>Sorry, link has broken or doesn't exist</p>
                    <p>
                        <router-link to="/login">Login</router-link>
                    </p>
                </div>
            </div>
        </div>
        <loading ref="loading"></loading>
        <notify ref="notify"></notify>
    </div>
</template>
<style scoped>
    .expired {
        width: 400px;
    }
    .expired p {
        font-size: 14px;
        margin-bottom: 0;
    }
    .broken {
        width: 400px;
    }
    .broken p {
        font-size: 14px;
        margin-bottom: 0;
    }
    .security-question .setup .form div {
        margin-bottom: 0;
    }
    .setup-account {
        height: 100%;
    }
    .security-question {
        height: 100%;
    }
    .question {
        margin-bottom: 1em !important;
    }
    .question label {
        font-weight: normal !important;
        margin-bottom: 0 !important;
    }
</style>

<script>
import loading from '@/components/Loading'
import notify from '@/components/Notify'
import AuthenticationService from '../services/AuthenticationService'
import cookies from '@/services/cookies'
export default {
  components: {
    loading,
    notify
  },
  data () {
    return {
      error: {
        answer: false
      },
      question: '',
      lastname: '',
      firstname: '',
      answer: '',
      broken: false,
      expired: false
    }
  },
  methods: {
    send (evt) {
      if (evt.keyCode == 13) {
        if (this.answer == '') {
          this.error.answer = true
        } else {
          this.error.answer = false
          let that = this

          let data = {
            token: this.$route.params.token,
            answer: this.answer
          }

          that.$refs.loading.load()

          this.$socket.emit('update-answer', data, function (data) {
            if (data.data === true) {
              that.$refs.loading.close()
              that.$refs.notify.load('Security question updated successfully')
              setTimeout(function () {
                that.$router.push('/login')
              }, 3000)
              that.answer = ''
            }

            if (data.data === false) {
              that.$refs.loading.close()
              that.answer = ''
              that.broken = false
              that.expired = true
            }
          })
        }
      }
    },
    submit () {
      if (this.answer == '') {
        this.error.answer = true
      } else {
        this.error.answer = false
        let that = this

        let data = {
          token: this.$route.params.token,
          answer: this.answer
        }

        that.$refs.loading.load()

        this.$socket.emit('update-answer', data, function (data) {
          if (data.data === true) {
            that.$refs.loading.close()
            that.$refs.notify.load('Security question updated successfully')
            that.answer = ''
          }

          if (data.data === false) {
            that.$refs.loading.close()
            that.answer = ''
            that.broken = false
            that.expired = true
          }
        })
      }
    }
  },
  mounted () {
    let that = this
    this.$refs.loading.load()
    AuthenticationService.check_link({ token: this.$route.params.token }).then((response) => {
      if (response.data.found) {
        if (response.data.expire === true) {
          that.$refs.loading.close()
          that.broke = false
          that.expired = true
        } else {
          that.$refs.loading.close()
          that.firstname = response.data.firstname
          that.lastname = response.data.lastname
          that.question = response.data.question
          that.broken = false
          that.expired = false
        }
      } else {
        that.$refs.loading.close()
        that.broken = true
        that.expired = false
      }
    }).catch((error) => {
      return console.log(error)
    })
  }
}
</script>
